import type { TimeStreamProject, AssetId } from 'owa-timestream-types';
import isCapturedAsset from '../../selectors/isCapturedAsset';
import refreshArray from '../refreshArray';

export default function updateRenderingOrder({ assets, renderingOrder }: TimeStreamProject) {
    const newRenderingOrder: AssetId[] = [];

    for (const [id, asset] of assets.entries()) {
        if (!asset.parentId && !asset.deleted && !isCapturedAsset(asset)) {
            newRenderingOrder.push(id);
        }
    }

    refreshArray(renderingOrder, newRenderingOrder);
}
